import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1f18cff0"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" Would you like to save the current project first? If so, press the \"Cancel\" button, then File -> Save... ");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Alert = _resolveComponent("Alert");
    const _component_PluginComponent = _resolveComponent("PluginComponent");
    return (_openBlock(), _createBlock(_component_PluginComponent, {
        infoPayload: _ctx.infoPayload,
        modelValue: _ctx.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.open) = $event)),
        cancelBtnTxt: "Cancel",
        actionBtnTxt: "New Project",
        onOnPopupDone: _ctx.onPopupDone,
        isActionBtnEnabled: true,
        onOnUserArgChanged: _ctx.onUserArgChanged
    }, {
        default: _withCtx(() => [
            _createVNode(_component_Alert, { type: "warning" }, {
                default: _withCtx(() => [
                    _hoisted_1
                ]),
                _: 1
            })
        ]),
        _: 1
    }, 8, ["infoPayload", "modelValue", "onOnPopupDone", "onOnUserArgChanged"]));
}
